import React, { Fragment } from 'react';
import Button from "../../components/atoms/Button";
import ButtonGroup from "../../components/molecules/ButtonGroup";
import OccupancyChart from "./charts/OccupancyChart";
import FloorOccupancyChart from './charts/FloorOccupancyChart';
import RawChart from "./charts/RawChart";
import QueueChart from "./charts/QueueChart";
import TransactionChart from './charts/TransactionChart';
import ZoneItem from "./components/ZoneItem";
import Counter from "./Counter";
import Dropdown from "../../components/atoms/Dropdown";
import RetailSectionTabs from "./components/RetailSectionTabs";
import Deferred from "./components/Deferred";
import SectionStage from "./components/SectionStage";
import RetailMap from './RetailMap';
import { v4 as uuidv4 } from "uuid";
import { MapContext } from './RetailLocation';
import DwellExportButton from './DwellExportButton';
import { Panel, PanelHeader, GroupLabel } from '../Concession/components/ConcessionUI';
import TrafficExportButton from "./TrafficExportButton";

export default function DayViews({
  getCurrentMinute,
  isToday,
  currentSection,
  setCurrentSection,
  dayType,
  currentLocation,
  data,
  currentTime,
  setCurrentTime,
  currentGame,
  peak,
  avg,
  findLabelByZoneId,
  getGatesOpenTime,
  selectedDate,
  zones,
  currentSeries,
  sort,
  setSort,
  showAllMaps,
  setShowAllMaps,
  autoFetchEnabled,
  setAutoFetchEnabled,
  setOccupancyAutoFetchEnabled,
  occupancyAutoFetchDidComplete,
  setOccupancyAutoFetchDidComplete,
  backgroundLoading,
  regularDayCount,
  counterDataAvailable,
  pregameCount,
  gatesOpenCount,
  firstPitchCount,
  counterSensorInfoData,
  counterTrafficDataList,
  overviewTrafficDataList,
  overviewSelectedDates,
  overviewGameTitlesList,
  queueTimeData,
  queueTimeDataMiniMap,
  transactionTimeData,
  transactionTimeDataMiniMap,
  zoneLabels,
  setZoneLabels,
}) {
  if (getCurrentMinute() < currentLocation.doorsOpenTime && isToday) {
    return (
      <div style={{ height: "500px" }}>
        <div className="m-auto w-100 text-center">
          Opens At 10:00 AM EST
        </div>
      </div>
    );
  }

  const getSortedZones = () => {
    return [...zones].sort((a, b) => {
      switch (sort) {
        case 'zone-id':
          return a.zoneId - b.zoneId;
        case 'current':
          const currentA = data[currentTime]?.traffic.find(y => y.id === a.zoneId)?.traffic || 0;
          const currentB = data[currentTime]?.traffic.find(y => y.id === b.zoneId)?.traffic || 0;
          return currentB - currentA;
        case 'peak':
          const peakA = Math.max(...data.map(d =>
            d.traffic.find(y => y.id === a.zoneId)?.traffic || 0
          ));
          const peakB = Math.max(...data.map(d =>
            d.traffic.find(y => y.id === b.zoneId)?.traffic || 0
          ));
          return peakB - peakA;
        default:
          return 0;
      }
    });
  };

  return (
    <div className="rx-day">
      <div className="d-flex">
        <div className="w-100">
          <RetailSectionTabs
            currentSection={currentSection}
            setCurrentSection={setCurrentSection}
            currentLocation={currentLocation}
            dayType={dayType}
            isToday={isToday}
            data={data}
            currentTime={currentTime}
            peak={peak}
            avg={avg}
            counterDataAvailable={counterDataAvailable}
            pregameCount={pregameCount}
            gatesOpenCount={gatesOpenCount}
            firstPitchCount={firstPitchCount}
            regularDayCount={regularDayCount}
            queueTimeData={queueTimeData}
            counterSensorInfoData={counterSensorInfoData}
          />
          
          <SectionStage section={currentSection}>
            {currentLocation.sectionTypes.MAP && currentSection === 'Map' && (
              <div>
                <div className="fixed-h">
                  <Deferred height={640}>
                    <RetailMap
                      currentLocation={currentLocation}
                      data={data}
                      currentTime={currentTime}
                      setCurrentTime={setCurrentTime}
                      isToday={isToday}
                      dayType={dayType}
                      currentGame={currentGame}
                      peak={peak}
                      avg={avg}
                      findLabelByZoneId={findLabelByZoneId}
                      getCurrentMinute={getCurrentMinute}
                      getGatesOpenTime={getGatesOpenTime}
                      setOccupancyAutoFetchEnabled={setOccupancyAutoFetchEnabled}
                      occupancyAutoFetchDidComplete={occupancyAutoFetchDidComplete}
                      setOccupancyAutoFetchDidComplete={setOccupancyAutoFetchDidComplete}
                      queueTimeData={queueTimeData}
                      queueTimeDataMiniMap={queueTimeDataMiniMap}
                      transactionTimeData={transactionTimeData}
                      transactionTimeDataMiniMap={transactionTimeDataMiniMap}
                      isAnalyticsView={false}
                    />
                  </Deferred>
                  {/* <div style={{marginTop: '32px'}} className="between">
                    <div>
                      <Button text="Sort:" className="border-0" />
                      <ButtonGroup>
                        <Dropdown
                          classNameBtn="btn"
                          target="sorts"
                          className="btn-group"
                          text={
                            sort === "zone-id"
                              ? "Zone ID"
                              : sort === "current"
                                ? "Current Occupancy"
                                : "Peak Occupancy"
                          }
                          icon="filter-left">
                          {currentLocation.sortOptions.map((x) => (
                            <Fragment key={uuidv4()}>
                              {x.code !== sort && (
                                <button
                                  onClick={() => setSort(x.code)}
                                  className="dropdown-item">
                                  {x.name}
                                </button>
                              )}
                            </Fragment>
                          ))}
                        </Dropdown>
                        <Button
                          onClick={() => setShowAllMaps(!showAllMaps)}
                          icon={showAllMaps ? "eye-slash" : "eye"}
                          text={(showAllMaps ? "Hide" : "Show") + " All Maps"}
                          className="border-0"
                        />
                      </ButtonGroup>
                    </div>
                  </div> */}
                  <Deferred delay={80} height={300}>
                    <MapContext.Provider value={[showAllMaps, setShowAllMaps]}>
                      <Panel className="rx-zones-panel">
                        <PanelHeader
                          title="Zone details"
                          subtitle="Current and peak occupancy for every zone. Admins can rename a zone by editing its name."
                        />
                      <div className="rx-zone-grid">
                        {getSortedZones().map((x) => (
                          <ZoneItem
                            key={x.zoneId}
                            currentLocation={currentLocation}
                            currentSeries={currentSeries}
                            currentGame={currentGame}
                            dayType={dayType}
                            x={x}
                            data={
                              data[currentTime]?.traffic.find(
                                (y) => y.id === x.zoneId
                              )?.traffic || 0
                            }
                            zoneLabels={zoneLabels}
                            setZoneLabels={setZoneLabels}
                          />
                        ))}
                      </div>
                      </Panel>
                    </MapContext.Provider>
                  </Deferred>
                </div>
              </div>
            )}

            {currentLocation.sectionTypes.COUNTER && 
             selectedDate !== null &&
             currentSection === 'Counter' && (
              <div className="fixed-h">
                <Deferred height={560}>
                  <Counter
                    dayType={dayType}
                    isToday={isToday}
                    selectedDate={selectedDate}
                    currentLocation={currentLocation}
                    currentGame={currentGame}
                    autoFetchEnabled={autoFetchEnabled}
                    setAutoFetchEnabled={setAutoFetchEnabled}
                    backgroundLoading={backgroundLoading}
                    regularDayCount={regularDayCount}
                    counterDataAvailable={counterDataAvailable}
                    pregameCount={pregameCount}
                    gatesOpenCount={gatesOpenCount}
                    firstPitchCount={firstPitchCount}
                    counterSensorInfoData={counterSensorInfoData}
                    counterTrafficDataList={counterTrafficDataList}
                    occupancyData={data}
                  />
                </Deferred>
              </div>
            )}

            {currentLocation.sectionTypes.CHARTS && 
             data.length !== 0 && 
             currentSection === 'Charts' && (
              <div className="fixed-h rx-chart-stack">
                {/* we only want to show retail map and occupancy chart if it is not max occupancy 0 */}
                {dayType === "game" && currentLocation.maxOccupancy != 0 && (
                  <Deferred height={640}>
                    <RetailMap
                      currentLocation={currentLocation}
                      data={data}
                      currentTime={currentTime}
                      setCurrentTime={setCurrentTime}
                      isToday={isToday}
                      dayType={dayType}
                      currentGame={currentGame}
                      peak={peak}
                      avg={avg}
                      findLabelByZoneId={findLabelByZoneId}
                      getCurrentMinute={getCurrentMinute}
                      getGatesOpenTime={getGatesOpenTime}
                      setOccupancyAutoFetchEnabled={setOccupancyAutoFetchEnabled}
                      occupancyAutoFetchDidComplete={occupancyAutoFetchDidComplete}
                      setOccupancyAutoFetchDidComplete={setOccupancyAutoFetchDidComplete}
                      queueTimeData={queueTimeData}
                      queueTimeDataMiniMap={queueTimeDataMiniMap}
                      transactionTimeData={transactionTimeData}
                      transactionTimeDataMiniMap={transactionTimeDataMiniMap}
                      isAnalyticsView={true}
                    />
                  </Deferred>
                )}
                {currentLocation.maxOccupancy != 0 && (
                  <>
                    <GroupLabel>Occupancy</GroupLabel>
                    <Deferred delay={80} height={420}>
                      <OccupancyChart data={data} currentLocation={currentLocation} dayType={dayType} currentGame={currentGame} />
                    </Deferred>
                    <Deferred delay={160} height={420}>
                      <RawChart data={data} currentLocation={currentLocation} dayType={dayType} currentGame={currentGame}/>
                    </Deferred>
                    {/* Floor chart only renders for multi-floor stores, so only reserve space for those */}
                    {(currentLocation.floors?.length || 0) > 1 && (
                      <Deferred delay={240} height={420}>
                        <FloorOccupancyChart 
                          data={data} 
                          currentLocation={currentLocation} 
                          dayType={dayType} 
                          currentGame={currentGame} 
                        />
                      </Deferred>
                    )}
                  </>
                )}
                {((queueTimeData && currentLocation.queueTimeSensorIds.length > 0) || (transactionTimeData && currentLocation.transactionMeasurement)) && (
                  <GroupLabel>Queues and transactions</GroupLabel>
                )}
                {/* We only want to show the queue chart if the curent location has queueTimeSensor Ids */}
                {queueTimeData && currentLocation.queueTimeSensorIds.length > 0 && (
                  <Deferred delay={300} height={460}>
                    <QueueChart 
                      queueData={queueTimeData}
                      isToday={isToday}
                      currentLocation={currentLocation} 
                      dayType={dayType} 
                      setAutoFetchEnabled={setAutoFetchEnabled}
                      currentGame={currentGame}
                    />
                  </Deferred>
                )}
                {transactionTimeData && currentLocation.transactionMeasurement && (
                  <Deferred delay={360} height={460}>
                    <TransactionChart 
                      transactionData={transactionTimeData}
                      isToday={isToday}
                      currentLocation={currentLocation} 
                      dayType={dayType} 
                      setAutoFetchEnabled={setAutoFetchEnabled}
                      currentGame={currentGame}
                    />
                  </Deferred>
                )}
                {/* <DwellExportButton
                  currentLocation={currentLocation}
                  findLabelByZoneId={findLabelByZoneId}
                />
                <TrafficExportButton currentLocation={currentLocation} /> */}
              </div>
            )}
          </SectionStage>
        </div>
      </div>
    </div>
  );
}
